// Material Kit 2 React pages
import Webinar from "pages/Webinar";

export default function WebinarPage() {
  return <Webinar />;
}
